<div class="flex h-full flex-col overflow-y-scroll">
  <div
    class="fixed z-header flex h-navbar w-full items-center justify-between gap-3 border-0 border-b border-solid border-default bg-surface-page p-3"
  >
    <div class="flex h-full items-center">
      <sb-logo class="w-36" />
    </div>

    <sb-header-avatar
      class="h-full"
      [employee]="authenticatedUser"
      [size]="30"
      [notificationCount]="0"
    ></sb-header-avatar>
  </div>
  <sb-profile-dropdown [open]="profileDropdownOpen$ | async"></sb-profile-dropdown>

  <div class="mt-navbar flex flex-1 items-center justify-center bg-surface p-3">
    <div
      class="flex w-96 max-w-full flex-col items-center gap-6 rounded-3xl border border-solid border-default bg-surface-page p-10"
    >
      <div class="flex rounded-xl bg-brand-subtle p-6 text-brand">
        <sb-icon [name]="'stopwatch'" [size]="'2xl'" />
      </div>
      <div class="flex flex-col gap-4 text-center">
        <h4 class="text-2xl font-bold text-default">
          {{ 'Welcome back [firstName]!' | translate: { firstName: authenticatedUser.first_name } }}
        </h4>
        <p class="text-support">
          {{ 'Your subscription is currently paused.' | translate }}
          @if (canManageAccount) {
            <span>{{ 'Resume your subscription below.' | translate }}</span>
          } @else {
            <span>{{ 'To resume your subscription please contact the account manager.' | translate }}</span>
          }
        </p>
      </div>
      @if (canManageAccount) {
        <button sb-button [color]="'primary'" (click)="resumeSubscription()" [sbLadda]="loading">
          {{ 'Resume subscription' | translate }}
        </button>
      }
    </div>
  </div>
</div>
